/* Módulo «Suma un 2.º par · 25% OFF» de las fichas de anteojos de sol.
 *
 * Fuente única: docs/PLAN_SEGUNDO_PAR_SOL.md (§3 interacción, §3.4 textos,
 * §3.5 visual y accesibilidad, §6 medición) del repo bonoboss-reco.
 *
 * Archivo propio (S12). Los tres del módulo de lectura no se tocan.
 *
 * Lo que hay que saber antes de cambiarlo:
 *
 * · El ahorro NUNCA se inventa: se calcula contra el carro real con la regla
 *   que aplica Shopify (§1.7) — 25 % de los ⌊n/2⌋ lentes más baratos del
 *   carro. Con 1 par ya adentro, el 2.º par de esta ficha no aporta un 25 %
 *   nuevo: lo aporta el principal. Por eso hay TRES restas distintas (§3.1):
 *     ahorroPrincipal — lo que aporta el par principal sobre el carro de hoy
 *                       (es lo que dice la píldora);
 *     ahorroTile      — lo que aporta ADEMÁS el 2.º par (el resumen, el
 *                       tachado del tile: puede ser $0 y entonces no se tacha);
 *     ahorroTotal     — lo que aporta agregar los DOS, que es exactamente lo
 *                       que va a bajar el carro. El botón y el recibo salen de
 *                       este, o prometen de más: con un óptico en el carro,
 *                       sumar 2 pares de sol cuesta $69.825 y no $79.800,
 *                       porque la tercera unidad completa un par (Q1).
 * · El carro se lee con la Section Rendering API (`?sections=bb-sp-carro`), no
 *   con /cart.js: hace falta saber qué líneas cubre el 25 %, y eso lo decide
 *   `snippets/bb-promo-2do-par.liquid` (tipo de producto + exclusión por
 *   metafield), cosa que /cart.js no trae.
 * · La cohorte la pone `bb-cohorte.liquid` y el estampado en el carro lo hace
 *   `bb-color-tap.js` en `ajaxProduct:added`. Acá no se hace ninguna de las
 *   dos cosas: el módulo dispara ese evento y el estampado sale solo.
 * · En la vista previa del theme el módulo se ve pero NO mide (los eventos
 *   quedan en window.__bbEventos para poder verificarlos).
 */
(function () {
  'use strict';
  if (window.__bbSegundoParSol) return;
  window.__bbSegundoParSol = true;

  var ESPERA_ADD = 8000;   /* ms sin respuesta tras los que el botón se reactiva (U24) */

  function init() {
    var root = document.querySelector('[data-bbs]');
    var centinela = document.querySelector('[data-bbs-centinela]');
    if (!root && !centinela) return;

    var info = window.bbCohorte || {};
    var preview = !!info.preview || !!window.bbSpPreview;
    var cohorte = (window.bbSpCohorte === 'a') ? 'a' : 'b';

    var registro = (window.__bbEventos = window.__bbEventos || []);
    function track(nombre, params) {
      params = params || {};
      registro.push({ n: nombre, p: params, t: Date.now() });
      if (preview) return;
      var privacy = window.Shopify && Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;
      try {
        if (typeof window.gtag === 'function') window.gtag('event', nombre, params);
        else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: nombre }, params));
      } catch (e) {}
    }

    /* El centinela mide el ALCANCE con el mismo criterio en las dos cohortes:
       en la cohorte a el módulo no se pinta, pero el punto donde habría estado
       sí entra en pantalla (§6). Sin esto, «cuánta gente llegó a verlo» no se
       puede comparar entre brazos. */
    if (centinela && 'IntersectionObserver' in window) {
      var obsA = new IntersectionObserver(function (entradas) {
        if (!entradas.some(function (e) { return e.isIntersecting; })) return;
        obsA.disconnect();
        track('bb_sp_sol_alcance_' + cohorte, { handle: (root && root.dataset.handle) || '' });
      }, { threshold: 0 });
      obsA.observe(centinela);
    }

    if (!root) return;
    var d = root.dataset;
    var modo = d.modo;
    var activo = modo === 'todos' || (modo === 'ab' && cohorte === 'b');
    var seccion = document.getElementById('shopify-section-' + d.sectionId) || document;
    var form = seccion.querySelector('form[action*="/cart/add"]');
    var botonPagina = form && form.querySelector('[data-add-to-cart]');
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pct = parseInt(d.pct, 10) || 0;
    var umbral = parseInt(d.umbral, 10) || 0;
    var decirEnvio = d.envio === 'true';
    var ocultarBarra = d.barraOculta === 'true';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var grid = root.querySelector('[data-bbs-grid]');
    var sub = root.querySelector('[data-bbs-sub]');
    var aviso = root.querySelector('[data-bbs-aviso]');
    var btnMas = root.querySelector('[data-bbs-mas]');

    var tiles = Array.prototype.map.call(root.querySelectorAll('[data-bbs-tile]'), function (nodo) {
      var vs = [];
      try { vs = JSON.parse(nodo.getAttribute('data-variants') || '[]'); } catch (e) {}
      /* El tile lo pinta Liquid con UNA variante concreta —en el tile 1, la del
         color que NO comparte tokens con el principal (`bb-segundo-par-sol.liquid`
         l.~100); en los demás, la primera con stock que no pase del precio del
         principal—, y la lleva en `data-key` = `handle:variantId`.
         `data-variants`, en cambio, va en el orden del catálogo. Arrancar en 0
         hacía que el panel, el recibo, el anuncio y el POST al carro usaran la
         PRIMERA variante del producto, que en el tile 1 es casi siempre el mismo
         color que el par principal: el tile decía «Otro color: Negro» y al carro
         se iban dos Brown. Medido el 23-sep en acacia-rpet-brown,
         galapagos-polarizado y orson-rpet-polarizado. */
      var bbClave = nodo.getAttribute('data-key') || '';
      var bbVid = parseInt(bbClave.slice(bbClave.lastIndexOf(':') + 1), 10) || 0;
      var bbIdx = 0;
      for (var bbK = 0; bbK < vs.length; bbK++) {
        if (vs[bbK].i === bbVid) { bbIdx = bbK; break; }
      }
      return {
        nodo: nodo,
        input: nodo.querySelector('.bbs__radio'),
        label: nodo.querySelector('.bbs__label'),
        sumar: nodo.querySelector('[data-bbs-sumar]'),
        precio: nodo.querySelector('[data-bbs-precio]'),
        colorTxt: nodo.querySelector('[data-bbs-color]'),
        foto: nodo.querySelector('.bbs__foto img'),
        handle: nodo.getAttribute('data-handle'),
        title: nodo.getAttribute('data-title'),
        src: nodo.getAttribute('data-src'),
        pos: parseInt(nodo.getAttribute('data-pos'), 10) || 0,
        pct: parseInt(nodo.getAttribute('data-pct'), 10) || 0,
        dos: nodo.getAttribute('data-dos') === 'true',
        variantes: vs,
        idx: bbIdx,
        eraElegido: false
      };
    });

    var estado = {
      elegido: null,
      carro: null,        /* {lineas:[{precio,cantidad,elegible,sol}], total, descuento} */
      ocupado: false,
      pildoraEstado: 'elegir'
    };

    function money(cents) {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
      return '$' + Math.round(cents / 100).toLocaleString('es-CL');
    }

    function fill(txt, vals) {
      return String(txt || '').replace(/\{(\w+)\}/g, function (m, k) {
        return vals[k] != null ? vals[k] : m;
      });
    }

    /* ---------------------------------------------------------------------
       La fórmula (U08). D(c) = 25 % de los ⌊n/2⌋ lentes más baratos de c.
       Desde el 18-sep el descuento de lentes y el de accesorios son dos, así
       que en `c` solo entran los lentes cubiertos.
       --------------------------------------------------------------------- */
    function D(precios) {
      if (!pct || !precios.length) return 0;
      var orden = precios.slice().sort(function (a, b) { return a - b; });
      var n = Math.floor(orden.length / 2);
      var suma = 0;
      for (var i = 0; i < n; i++) suma += Math.round(orden[i] * pct / 10000) * 100;
      return suma;
    }

    function preciosCarro() {
      if (!estado.carro) return [];
      var out = [];
      estado.carro.lineas.forEach(function (l) {
        if (!l.elegible) return;
        for (var i = 0; i < l.cantidad; i++) out.push(l.precio);
      });
      return out;
    }

    function precioPrincipal() { return parseInt(d.price, 10) || 0; }

    /* Lo que agrega el 2.º par, encima de lo que ya aporta el principal. */
    function ahorroTile(t) {
      var base = preciosCarro();
      var conP = base.concat([precioPrincipal()]);
      var conPT = conP.concat([variante(t).p]);
      return Math.max(0, D(conPT) - D(conP));
    }

    /* Lo que baja el carro al agregar los DOS pares. NO es ahorroTile: con un
       número impar de lentes cubiertos ya en el carro, la unidad que completa
       el par se lleva un 25 % que ninguna de las dos restas anteriores ve
       entera. Es el número del botón y del recibo, y el que se compara después
       contra `cart.total_discount` (defecto Q1, 23-sep). */
    function ahorroTotal(t) {
      var base = preciosCarro();
      var conPT = base.concat([precioPrincipal(), variante(t).p]);
      return Math.max(0, D(conPT) - D(base));
    }

    /* Lo que aporta el par principal sobre el carro de hoy (píldora). */
    function ahorroPrincipal() {
      var base = preciosCarro();
      return Math.max(0, D(base.concat([precioPrincipal()])) - D(base));
    }

    function totalCarro() { return estado.carro ? estado.carro.total : 0; }

    function variante(t) { return t.variantes[t.idx] || t.variantes[0] || { p: 0, i: 0, t: '' }; }

    /* --------------------------------------------------------------------- */

    function pintarPrecio(t) {
      var v = variante(t);
      var ahorro = ahorroTile(t);
      var nodo = t.precio;
      nodo.textContent = '';
      if (!ahorro) {
        var solo = document.createElement('span');
        solo.className = 'bbs__p1';
        solo.textContent = money(v.p);
        nodo.appendChild(solo);
        return;
      }
      var s = document.createElement('s');
      s.className = 'bbs__p0';
      var oculto = document.createElement('span');
      oculto.className = 'visually-hidden';
      oculto.textContent = d.tNormal + ' ';
      s.appendChild(oculto);
      s.appendChild(document.createTextNode(money(v.p)));
      var p1 = document.createElement('span');
      p1.className = 'bbs__p1';
      p1.appendChild(document.createTextNode(money(v.p - ahorro)));
      var p2 = document.createElement('span');
      p2.className = 'bbs__p2';
      p2.textContent = ' ' + d.tComo;
      p1.appendChild(p2);
      nodo.appendChild(s);
      nodo.appendChild(p1);
    }

    function pintarPrecios() { tiles.forEach(pintarPrecio); }

    /* --- panel del par elegido, dentro de la grilla (U01) --- */
    var panel = null;

    function columnas() {
      var g = window.getComputedStyle(grid).gridTemplateColumns || '';
      var n = g.split(' ').filter(function (x) { return x && x !== 'none'; }).length;
      return n > 0 ? n : 1;
    }

    function visibles() {
      return tiles.filter(function (t) { return !t.nodo.hidden; });
    }

    function colocarPanel() {
      if (!panel || !estado.elegido) return;
      var lista = visibles();
      var i = lista.indexOf(estado.elegido);
      if (i < 0) return;
      var cols = columnas();
      var siguiente = (Math.floor(i / cols) + 1) * cols;
      var ref = lista[siguiente] ? lista[siguiente].nodo : null;
      if (ref) grid.insertBefore(panel, ref);
      else grid.appendChild(panel);
    }

    function textoColor(t) {
      var v = variante(t);
      if (t.dos) {
        var partes = String(v.t).split(' / ');
        return 'color: ' + partes[0] + (partes[1] ? ' · lente ' + partes[1] : '');
      }
      if (t.src === 'otro-color') return fill(d.tColorTile1 || 'Otro color: {color}', { color: v.t });
      return v.t;
    }

    function construirPanel() {
      var t = estado.elegido;
      var v = variante(t);
      panel = document.createElement('div');
      panel.className = 'bbs__panel';
      panel.setAttribute('data-bbs-panel', '');

      var rot = document.createElement('p');
      rot.className = 'bbs__rot';
      var rotId = 'BbsRot-' + d.sectionId;
      rot.id = rotId;
      panel.appendChild(rot);

      var minis = document.createElement('div');
      minis.className = 'bbs__minis';
      minis.setAttribute('role', 'group');
      minis.setAttribute('aria-labelledby', rotId);
      panel.appendChild(minis);

      var recibo = document.createElement('p');
      recibo.className = 'bbs__recibo';
      panel.appendChild(recibo);

      var res = document.createElement('p');
      res.className = 'bbs__res';
      var resTxt = document.createElement('span');
      res.appendChild(resTxt);
      var quitar = document.createElement('button');
      quitar.type = 'button';
      quitar.className = 'bbs__quitar';
      quitar.textContent = d.tQuitar || 'Quitar 2.º par';
      quitar.addEventListener('click', function () {
        var anterior = estado.elegido;
        elegir(null);
        if (anterior && !anterior.nodo.hidden) anterior.input.focus();
      });
      res.appendChild(quitar);
      panel.appendChild(res);

      var cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'btn btn--full bbs__cta';
      cta.setAttribute('data-bbs-cta', '');
      cta.addEventListener('click', agregarDos);
      panel.appendChild(cta);

      panel.__rot = rot;
      panel.__minis = minis;
      panel.__recibo = recibo;
      panel.__res = resTxt;
      panel.__cta = cta;
      return panel;
    }

    function pintarMinis() {
      var t = estado.elegido;
      var minis = panel.__minis;
      minis.textContent = '';
      t.variantes.forEach(function (v, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bbs__mini' + (v.f ? '' : ' bbs__mini--txt');
        b.setAttribute('aria-pressed', k === t.idx ? 'true' : 'false');
        b.setAttribute('aria-label', v.t);
        if (v.f) {
          var img = document.createElement('img');
          img.src = v.f;
          img.alt = '';
          img.decoding = 'async';
          b.appendChild(img);
        } else {
          /* Sin packshot ni foto de variante, el color queda en texto: nunca
             se pinta la foto de OTRO color (U05). */
          b.textContent = v.t;
        }
        b.addEventListener('click', function () {
          if (t.idx === k) return;
          t.idx = k;
          pintarPrecio(t);
          /* Las fotos de las miniaturas vienen a 128 px (64 CSS × DPR 2); la
             del tile es la misma imagen pedida a 360. Sin foto para ese color,
             el tile se queda con la que tenía: nunca se pone la de otro. */
          if (t.foto && v.f) t.foto.setAttribute('src', v.f.replace(/([?&])width=128/, '$1width=360'));
          if (t.colorTxt) t.colorTxt.textContent = textoColor(t);
          pintarPanel();
          anunciar();
          track('bb_sp_sol_color2', { handle: t.handle, color: v.t, pos: t.pos });
        });
        minis.appendChild(b);
      });
    }

    function pintarPanel() {
      var t = estado.elegido;
      if (!t || !panel) return;
      var v = variante(t);
      var ahorro = ahorroTile(t);
      var ahorroTot = ahorroTotal(t);
      /* Lo que del ahorro total se lleva el par PRINCIPAL. Con el carro vacío o
         con un número par de lentes cubiertos es 0 y el recibo queda como
         siempre; con uno impar, el 25 % lo gana el principal al emparejarse con
         lo que ya estaba, y el recibo lo tiene que mostrar ahí o no suma lo
         mismo que el botón. */
      var ahorroPrin = Math.max(0, ahorroTot - ahorro);
      var total = precioPrincipal() + v.p - ahorroTot;

      var mismo = t.src === 'otro-color' && String(v.t).toLowerCase() === String(d.color || '').toLowerCase();
      panel.__rot.textContent = '';
      var fuerte = document.createElement('b');
      fuerte.textContent = t.title;
      panel.__rot.appendChild(fuerte);
      panel.__rot.appendChild(document.createTextNode(' · ' + fill(mismo ? d.tRotuloIgual : d.tRotulo, { color: v.t })));

      panel.__recibo.textContent = '';
      var l1 = document.createElement('span');
      l1.textContent = ahorroPrin
        ? fill(d.tRecibo2, { producto: d.title, color: '', precio: money(precioPrincipal() - ahorroPrin), antes: money(precioPrincipal()) }).replace(/\s{2,}/g, ' ')
        : fill(d.tRecibo1, { producto: d.title, precio: money(precioPrincipal()) });
      var l2 = document.createElement('span');
      l2.textContent = ahorro
        ? fill(d.tRecibo2, { producto: t.title, color: v.t, precio: money(v.p - ahorro), antes: money(v.p) })
        : fill(d.tRecibo1, { producto: t.title + ' ' + v.t, precio: money(v.p) });
      panel.__recibo.appendChild(l1);
      panel.__recibo.appendChild(l2);

      /* U16: el 2.º par desbloquea el envío gratis solo si sin él no llegaba. */
      var cruzaEnvio = decirEnvio && umbral > 0 &&
                       totalCarro() + precioPrincipal() < umbral &&
                       totalCarro() + total >= umbral;
      if (!ahorro) panel.__res.textContent = d.tResCero;
      else panel.__res.textContent = fill(cruzaEnvio ? d.tResEnvio : d.tRes, { ahorro: money(ahorro) });

      Array.prototype.forEach.call(panel.__minis.children, function (b, k) {
        b.setAttribute('aria-pressed', k === t.idx ? 'true' : 'false');
      });

      if (!estado.ocupado) {
        panel.__cta.textContent = fill(d.tCta, { total: money(total) });
        panel.__cta.disabled = !v.i;
      }
    }

    function anunciar() {
      var t = estado.elegido;
      if (!aviso) return;
      if (!t) { aviso.textContent = ''; return; }
      var v = variante(t);
      var ahorro = ahorroTile(t);
      aviso.textContent = fill(d.tAnuncio, {
        modelo: t.title, color: v.t,
        total: money(precioPrincipal() + v.p - ahorroTotal(t)),
        ahorro: money(ahorro)
      });
    }

    /* La barra fija se esconde con una clase en <html>, no tocando su propio
       estilo: su IntersectionObserver (bb-sticky-cta.liquid) sigue mandando
       `is-visible` y no hay que pelear con él. `bb-barra.js` vigila la clase de
       <html> y baja el globo del chat en el mismo momento. */
    function barra(oculta) {
      if (!ocultarBarra) return;
      document.documentElement.classList.toggle('bb-sp-sol-barra-off', !!oculta);
    }

    /* Con un tile elegido la barra fija se va mientras cualquier parte del
       módulo esté en pantalla (U07): si no, quedan dos botones negros a la
       vista que hacen cosas distintas —uno agrega 2 pares y el otro 1—. */
    var obsBarra = null;
    function vigilarBarra() {
      if (!ocultarBarra || !('IntersectionObserver' in window)) return;
      if (obsBarra) obsBarra.disconnect();
      obsBarra = new IntersectionObserver(function (entradas) {
        var dentro = entradas.some(function (e) { return e.isIntersecting; });
        barra(!!estado.elegido && dentro);
      }, { threshold: 0 });
      obsBarra.observe(root);
    }

    /* `conservar` existe por el 422: ahí se limpia la selección DESPUÉS de
       escribir «se agotó recién» en el role=status, y sin esta bandera el
       propio elegir(null) borraba el aviso que acababa de escribir. Lo
       encontró la compuerta, no la lectura del código. */
    function elegir(t, conservar) {
      var previo = estado.elegido;
      estado.elegido = t;
      if (aviso && !t && !conservar) aviso.textContent = '';
      tiles.forEach(function (x) {
        x.nodo.classList.toggle('is-on', x === t);
        if (x.input) x.input.checked = x === t;
        if (x.sumar) x.sumar.textContent = (x === t) ? x.sumar.getAttribute('data-sumado') : x.sumar.getAttribute('data-sumar');
      });
      if (!t) {
        if (panel && panel.parentNode) panel.parentNode.removeChild(panel);
        barra(false);
        return;
      }
      if (!panel) construirPanel();
      colocarPanel();
      pintarMinis();
      pintarPanel();
      anunciar();
      if (previo !== t) {
        try { panel.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { panel.scrollIntoView(); }
      }
      vigilarBarra();
      barra(true);
    }

    /* --- agregar los dos pares --- */
    function itemPrincipal() {
      var datos = new FormData(form);
      var item = { id: parseInt(datos.get('id'), 10), quantity: parseInt(datos.get('quantity'), 10) || 1 };
      var props = {};
      datos.forEach(function (valor, clave) {
        var m = /^properties\[(.+)\]$/.exec(clave);
        if (m && typeof valor === 'string' && valor !== '') props[m[1]] = valor;
      });
      if (Object.keys(props).length) item.properties = props;
      if (datos.get('selling_plan')) item.selling_plan = datos.get('selling_plan');
      return item;
    }

    function postCarro(items) {
      var url = (window.theme && theme.routes && theme.routes.cartAdd) || (raiz + 'cart/add.js');
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, json: j }; });
      });
    }

    function avisarDrawer(texto) {
      /* El drawer se abre ENCIMA del módulo, así que el aviso del 422 va en
         los dos lugares (U24): acá y en el panel del carro. */
      var intentos = 0;
      (function poner() {
        var caja = document.querySelector('#CartDrawer .drawer__scrollable');
        if (caja) {
          var previo = caja.querySelector('[data-bbs-drawer-aviso]');
          if (previo) previo.parentNode.removeChild(previo);
          var p = document.createElement('p');
          p.className = 'bbs__aviso';
          p.setAttribute('data-bbs-drawer-aviso', '');
          p.setAttribute('role', 'status');
          p.textContent = texto;
          caja.insertBefore(p, caja.firstChild);
          return;
        }
        if (++intentos < 12) setTimeout(poner, 250);
      })();
    }

    var eventoPropio = false;
    function avisarTheme(json) {
      eventoPropio = true;
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: (json.items || [json])[0], addToCartBtn: botonPagina },
        bubbles: true
      }));
      eventoPropio = false;
    }

    function cargando(on, texto) {
      if (!panel) return;
      var cta = panel.__cta;
      estado.ocupado = on;
      cta.disabled = on;
      cta.classList.toggle('btn--loading', on);
      if (on) {
        cta.setAttribute('aria-busy', 'true');
        cta.textContent = texto || d.tCtaLoad;
      } else {
        cta.removeAttribute('aria-busy');
      }
      /* El tile que se agotó (422) queda deshabilitado para siempre: si acá
         se le devolviera el radio, el cliente podría volver a elegir el par
         que la tienda acaba de decir que no tiene. */
      tiles.forEach(function (x) {
        if (x.input) x.input.disabled = on || x.nodo.classList.contains('is-unavailable');
      });
      if (panel.__minis) {
        Array.prototype.forEach.call(panel.__minis.children, function (b) { b.disabled = on; });
      }
    }

    function agregarDos() {
      var t = estado.elegido;
      if (!t || estado.ocupado || !form) return;
      var v = variante(t);
      var ahorro = ahorroTile(t);
      /* Lo que se compara con `cart.total_discount` es lo que bajan los DOS
         pares, no solo el 2.º: es lo que Shopify va a descontar de más. */
      var ahorroTot = ahorroTotal(t);
      var descAntes = estado.carro ? estado.carro.descuento : 0;
      cargando(true);
      var reloj = setTimeout(function () {
        cargando(false);
        if (aviso) aviso.textContent = d.tCtaError;
        pintarPanel();
      }, ESPERA_ADD);

      postCarro([itemPrincipal(), { id: v.i, quantity: 1, properties: { _bb_rec: 'w:segundo-par-sol', _bb_src: t.src } }])
        .then(function (res) {
          if (res.ok) {
            avisarTheme(res.json);
            track('bb_sp_sol_atc_' + cohorte, { pares: 2 });
            track('bb_sp_sol_add2', { handle: t.handle, pos: t.pos, src: t.src, color: v.t, ahorro: Math.round(ahorro / 100) });
            return comprobarDescuento(ahorroTot, descAntes);
          }
          /* 422: el 2.º par se agotó entre el render y el toque. Se agrega
             solo el principal y se dice en los dos lugares. */
          return postCarro([itemPrincipal()]).then(function (solo) {
            if (!solo.ok) throw new Error('add');
            avisarTheme(solo.json);
            track('bb_sp_sol_atc_' + cohorte, { pares: 1 });
            track('bb_sp_sol_422', { handle: t.handle, pos: t.pos });
            var texto = fill(d.tSinStock, { modelo: t.title, color: v.t, principal: d.title, precio: money(precioPrincipal()) });
            if (aviso) aviso.textContent = texto;
            avisarDrawer(texto);
            t.nodo.classList.add('is-unavailable');
            if (t.input) t.input.disabled = true;
            if (t.sumar) t.sumar.textContent = d.tAgotado;
            elegir(null, true);
          });
        })
        .catch(function () {
          if (aviso) aviso.textContent = d.tCtaError;
        })
        .then(function () {
          clearTimeout(reloj);
          cargando(false);
          /* Sin estado «ya tienes tu 2.º par»: el 25 % no tiene tope por orden
             (con 4 pares aplica a 2), así que el módulo sigue ofreciendo. */
          if (estado.elegido) elegir(null, !!(aviso && aviso.textContent));
          leerCarro();
        });
    }

    /* ¿Lo que se prometió es lo que descontó Shopify? Si no, se sabe el mismo
       día y no tres semanas después (§6, `desc_mismatch` debe ser ~0). */
    function comprobarDescuento(prometido, antes) {
      return leerCarro().then(function () {
        var ahora = estado.carro ? estado.carro.descuento : 0;
        var real = ahora - antes;
        if (Math.abs(real - prometido) <= 100) track('bb_sp_sol_desc_ok', { ahorro: Math.round(prometido / 100) });
        else track('bb_sp_sol_desc_mismatch', { prometido: Math.round(prometido / 100), real: Math.round(real / 100) });
      });
    }

    /* --- carro (Section Rendering API) --- */
    function leerCarro() {
      return fetch(raiz + '?sections=bb-sp-carro', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j['bb-sp-carro'];
          if (!html) throw new Error('sin seccion');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nodo = doc.getElementById('bb-sp-carro-json');
          if (!nodo) throw new Error('sin json');
          estado.carro = JSON.parse(nodo.textContent);
        })
        .catch(function () { estado.carro = null; })
        .then(function () {
          pintarPrecios();
          pintarPanel();
          pintarPildora();
        });
    }

    /* --- píldora-ancla (P1, U04) --- */
    var pildoraLista = false;
    function pintarPildora() {
      if (!activo) return;
      var pill = document.getElementById('bb-promo-pill');
      if (!pill) return;
      var elegibles = preciosCarro();
      var impar = elegibles.length % 2 === 1;
      var ahorro = ahorroPrincipal();
      var envio = decirEnvio && umbral > 0 && totalCarro() + precioPrincipal() >= umbral && totalCarro() < umbral;
      var svg = pill.querySelector('svg');

      pill.classList.add('bbs__pill-host');
      pill.textContent = '';
      if (svg) pill.appendChild(svg);

      if (impar && ahorro > 0 && estado.carro) {
        estado.pildoraEstado = 'ya-llevas';
        pill.appendChild(document.createTextNode(' ' + fill(envio ? d.tPillParEnvio : d.tPillPar, { ahorro: money(ahorro) })));
      } else {
        estado.pildoraEstado = 'elegir';
        var a = document.createElement('a');
        a.className = 'bbs__pill';
        a.href = '#bbs';
        a.appendChild(document.createTextNode(d.tPill + ' · '));
        var u = document.createElement('u');
        u.textContent = d.tPillVer;
        a.appendChild(u);
        a.addEventListener('click', function () {
          track('bb_sp_sol_pildora', { estado: estado.pildoraEstado, toque: 1, handle: d.handle });
          setTimeout(function () { try { root.focus({ preventScroll: true }); } catch (e) {} }, 400);
        });
        pill.appendChild(a);
      }
      /* Un solo evento con nombre propio (§6.8): el estado con el que la
         píldora se pintó, y el toque cuando lo hay. */
      if (!pildoraLista) {
        pildoraLista = true;
        track('bb_sp_sol_pildora', { estado: estado.pildoraEstado, toque: 0, handle: d.handle });
      }
    }

    function esperarPildora() {
      var intentos = 0;
      (function tick() {
        if (document.getElementById('bb-promo-pill')) { pintarPildora(); return; }
        if (++intentos < 20) setTimeout(tick, 200);
      })();
    }

    /* --- eventos de los tiles --- */
    tiles.forEach(function (t) {
      if (!t.input) return;
      t.nodo.addEventListener('pointerdown', function () { t.eraElegido = estado.elegido === t; });
      t.nodo.addEventListener('click', function (ev) {
        /* Segundo toque sobre el mismo tile = quitarlo. */
        if (t.input.disabled || !t.eraElegido || estado.elegido !== t) return;
        ev.preventDefault();
        t.eraElegido = false;
        elegir(null);
      });
      t.input.addEventListener('change', function () {
        if (!t.input.checked) return;
        elegir(t);
        track('bb_sp_sol_select', { handle: t.handle, pos: t.pos, src: t.src, color: variante(t).t });
      });
    });

    if (btnMas) {
      btnMas.addEventListener('click', function () {
        var abrir = btnMas.getAttribute('aria-expanded') !== 'true';
        tiles.forEach(function (t) {
          if (t.nodo.hasAttribute('data-extra')) t.nodo.hidden = !abrir;
        });
        btnMas.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        btnMas.textContent = abrir ? btnMas.getAttribute('data-menos') : btnMas.getAttribute('data-mas');
        colocarPanel();
        if (abrir) {
          var quinto = tiles.filter(function (t) { return t.nodo.hasAttribute('data-extra'); })[0];
          if (quinto && quinto.input) quinto.input.focus({ preventScroll: true });
          track('bb_sp_sol_vermas', { handle: d.handle, n: tiles.length });
        }
      });
    }

    /* El botón de la página, la barra fija y «Personalizar con receta» agregan
       SIEMPRE 1 par, haya o no un tile elegido (S3). El módulo no toca el
       envío del formulario: por eso tiene botón propio. Al abrir LensAdvisor
       se limpia la selección y vuelve la barra. */
    if (form) {
      form.addEventListener('ajaxProduct:added', function () {
        if (eventoPropio) return;
        track('bb_sp_sol_atc_' + cohorte, { pares: 1 });
        elegir(null);
        leerCarro();
      });
    }
    document.addEventListener('click', function (ev) {
      var la = ev.target.closest && ev.target.closest('lensadvizor-btn, .la-select-lenses-btn, [data-lensadvizor-btn]');
      if (la && estado.elegido) elegir(null);
    }, true);

    /* Cambia el color principal: solo el tile 1 reacciona, y EN SU LUGAR —no
       se reordena nada—. Si estaba mostrando justo la variante que el cliente
       acaba de elegir, pasa a la siguiente (§3.3). El resto de los tiles no
       depende del color principal. `variantChange` es el evento del theme;
       `variant:change` el que usa el módulo de lectura. */
    function alCambiarVariante(ev) {
      var v = ev.detail && ev.detail.variant;
      if (!v || !v.id) return;
      d.price = String(v.price);
      d.variant = String(v.id);
      d.color = String(v.title);
      var t1 = tiles.filter(function (t) { return t.src === 'otro-color'; })[0];
      if (t1 && t1.variantes.length > 1 && variante(t1).i === v.id) {
        var siguiente = 0;
        for (var k = 0; k < t1.variantes.length; k++) {
          if (t1.variantes[k].i !== v.id) { siguiente = k; break; }
        }
        t1.idx = siguiente;
        var nv = variante(t1);
        if (t1.foto && nv.f) t1.foto.setAttribute('src', nv.f.replace(/([?&])width=128/, '$1width=360'));
        if (t1.colorTxt) t1.colorTxt.textContent = textoColor(t1);
        if (estado.elegido === t1 && panel) { pintarMinis(); }
      }
      pintarPrecios();
      pintarPanel();
      pintarPildora();
    }
    document.addEventListener('variantChange', alCambiarVariante, true);
    document.addEventListener('variant:change', alCambiarVariante, true);

    window.addEventListener('resize', function () { colocarPanel(); });

    /* --- arranque --- */
    pintarPrecios();
    esperarPildora();
    leerCarro();

    /* El denominador del A/B: la ficha TENÍA bloque y candidatos. Se manda en
       las dos cohortes; lo que cambia es si se ve o no. */
    track('bb_sp_sol_view_' + cohorte, { handle: d.handle, n: tiles.length });

    /* Impresión real: los tiles entraron en pantalla, y cuántos se veían de
       verdad. Sin esto no se puede decidir 4 tiles contra 6 (S6, U28).
       El umbral es 0 y no 0,5: la grilla mide 840 px en un teléfono de 844,
       así que «la mitad de la grilla a la vista» no ocurre nunca y el evento
       no salía. Medido el 23-sep en la vista previa. Cuántos tiles se veían
       se cuenta a mano, tile por tile. */
    if (activo && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entradas) {
        if (!entradas.some(function (e) { return e.isIntersecting; })) return;
        obs.disconnect();
        var lista = visibles();
        var params = {
          handle: d.handle,
          n: lista.length,
          vis: lista.filter(function (t) {
            var r = t.nodo.getBoundingClientRect();
            var alto = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
            return r.height > 0 && alto / r.height >= 0.5;
          }).length
        };
        lista.slice(0, 6).forEach(function (t, i) { params['t' + (i + 1)] = t.handle + '|' + t.src; });
        track('bb_sp_sol_impresion', params);
      }, { threshold: 0 });
      obs.observe(grid);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
